import { render, staticRenderFns } from "./ThePayPeriod.vue?vue&type=template&id=860d2812&"
import script from "./ThePayPeriod.vue?vue&type=script&lang=js&"
export * from "./ThePayPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports